import { AnimatePresence, motion } from "motion/react";
import { SlapLogo } from "./slap-logo";

interface LoadingScreenProps {
	isLoading: boolean;
}

function LoadingScreen({ isLoading }: LoadingScreenProps) {
	return (
		<AnimatePresence mode="wait">
			{isLoading && (
				<motion.div
					className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-background"
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					exit={{
						opacity: 0,
						scale: 0.95,
						transition: { duration: 0.5, ease: [0.76, 0, 0.24, 1] },
					}}
				>
					<div className="relative">
						{/* Background glow effect behind the logo */}
						<motion.div
							className="absolute inset-0 rounded-full bg-primary/20 blur-3xl"
							animate={{
								scale: [0.8, 1.2, 0.8],
								opacity: [0.2, 0.4, 0.2],
							}}
							transition={{
								duration: 3,
								repeat: Number.POSITIVE_INFINITY,
								ease: "easeInOut",
							}}
						/>

						<div className="relative z-10 text-primary">
							<SlapLogo width={300} />
						</div>
					</div>

					<motion.div
						className="relative mt-12 flex flex-col items-center space-y-2"
						initial={{ opacity: 0, y: 20 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ delay: 0.5, duration: 0.5 }}
					>
						<div className="h-1 w-32 overflow-hidden rounded-full bg-neutral-200">
							<motion.div
								className="h-full bg-primary"
								initial={{ width: "0%" }}
								animate={{ width: "100%" }}
								transition={{ duration: 3.5, ease: "easeInOut" }}
							/>
						</div>
						<p className="text-sm font-medium uppercase tracking-widest text-neutral-400">
							Loading
						</p>
					</motion.div>
				</motion.div>
			)}
		</AnimatePresence>
	);
}

export { LoadingScreen };
